import React, { useState, useRef, useEffect } from "react";
import { edit_icon } from "../../../assets/imgs";
import { Table } from "../../../components/Table/Table";
import { alertList } from "../../redux/api/dummyJson";
import { URL } from "../../../Services/Constant";
import { post } from "../../../Services/ApiHandler";
import { toast } from "react-toastify";

const SiteAlertTypes = ({ getAlert, alertData, setAlertData }) => {
  const [data, setData] = useState([]);

  const [editIndex, setEditIndex] = useState(null);
  const [tempPriority, setTempPriority] = useState("");

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");

  // ref for inputs
  const inputRefs = useRef({});

  // Focus input automatically when editIndex changes
  useEffect(() => {
    if (editIndex !== null && inputRefs.current[editIndex]) {
      inputRefs.current[editIndex].focus();
    }
  }, [editIndex]);

  const handleChange = (event) => {
    const value = event.target.value;
    if (["1", "2", "3"].includes(value)) {
      setTempPriority(value);
    } else {
      setTempPriority("");
    }
  };

  const handleSave = (index, item) => {
    let formdata = new FormData();
    formdata.append("knf_company_site_id", item?.site_id);
    formdata.append("severity", tempPriority);
    formdata.append("name", item?.alert_type);
    post(URL.SITE_ALERT_TYPES_UPDATE, formdata)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          getAlert();
        }
      })
      .catch((err) => {
        console.log("err", err);
      });

    // setAlertData((prev) => {
    //   const updated = [...prev];
    //   updated[index].priority = tempPriority || updated[index].priority;
    //   return updated;
    // });
    setEditIndex(null);
    setTempPriority("");
  };

  const handleCancel = () => {
    setEditIndex(null);
    setTempPriority("");
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sNo",
        Cell: ({ row }) => <p>{(page - 1) * 10 + row.index + 1}</p>,
      },
      {
        Header: "Alert List",
        accessor: "alert_type",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Severity",
        accessor: "severity",
        Cell: ({ value, row }) => {
          const index = row.index;
          const isEditing = editIndex === index;

          return (
            <input
              className="input-box text-center w-50 f4"
              type="text"
              value={isEditing ? tempPriority : value} // <-- bind directly
              onChange={(e) => isEditing && handleChange(e)} // only handle when editing
              disabled={!isEditing}
              ref={(el) => {
                if (isEditing && el) el.focus(); // auto-focus when editing starts
              }}
            />
          );
        },
      },

      {
        Header: "Edit (priority count)",
        accessor: "",
        Cell: ({ row }) => {
          const index = row.index;
          return (
            <div className="d-flex ac-jc">
              {editIndex === index ? (
                <>
                  <button
                    onClick={() => handleSave(index, row.original)}
                    className="save-btn"
                  >
                    Save
                  </button>
                  <button onClick={handleCancel} className="cancel-btn">
                    Cancel
                  </button>
                </>
              ) : (
                <button
                  onClick={() => {
                    setEditIndex(index);
                    setTempPriority(alertData[index].priority);
                  }}
                  className="cust-btn"
                >
                  <img src={edit_icon} alt="" className="edit-btn" />
                </button>
              )}
            </div>
          );
        },
      },
    ],
    [editIndex, tempPriority, alertData, page]
  );

  return (
    <div className=" ">
      <div className="d-flex ac-jb w-100">
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Total: {alertData?.length ?? 0}
        </h2>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={alertData}
        show={true}
      />
    </div>
  );
};

export default SiteAlertTypes;
